import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">TrumpBud · Cannabis Coverage</p>
        <h1>Your Source for Cannabis Policy and Culture</h1>
        <p className="lede">
          Stay informed with the latest updates on cannabis laws, policies, and cultural insights in your area. 
          Our mission is to provide comprehensive coverage and educational resources to help you navigate the evolving landscape of cannabis.
        </p>
        <div className="cta-row">
          <a href="/latest-updates" target="_self">
            Explore Latest Updates
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Access Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Keep up with the latest changes in cannabis legislation and policy in your community. 
            Our coverage ensures you are always informed about your rights and responsibilities.
          </p>
        </article>
        <article>
          <h2>Legal Status Information</h2>
          <p>
            Understand the current legal status of cannabis in your area. We provide clear and concise information 
            to help you stay compliant and informed.
          </p>
        </article>
        <article>
          <h2>Educational Content</h2>
          <p>
            Dive into our resources that cover various aspects of cannabis culture, health benefits, and responsible use. 
            Empower yourself with knowledge and insights.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;